import React, { } from "react";
import {
    Tag, Skeleton
} from "antd";
import Container from "../../General/Container/Container";
import { PlusCircleFilled, MinusCircleFilled } from "@ant-design/icons";

const KeywordSuggestions = function ({
    list = [],
    included = [],
    loading,
    onClick = () => { }
}) {
    return (
        <Container className="input-suggestions">
            <span className="input-suggestions-title">Try these suggested keywords:</span>
            <Container className="input-suggestions-list dwrap gap-5p">
                {loading
                    ? "1111111".split("").map((i, idx) => <Skeleton.Button key={idx} active />)
                    : list.map((item) => {
                        return <Tag key={item} className="oi-tag suggestion" icon={included.includes(item) ? <MinusCircleFilled title="remove" style={{
                            cursor: "pointer"
                        }} onClick={() => {
                            onClick(item)
                        }} /> : <PlusCircleFilled title="add" style={{
                            cursor: "pointer",
                            color: "#3B82F6"
                        }} onClick={() => {
                            onClick(item, true)
                        }} />}>{item}</Tag>
                    })}
            </Container>
        </Container>
    );
};

export default KeywordSuggestions;
